/**
 * Created by Tiger on 24/02/2022.
 */

import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import reducer from '../reducer';

const composeEnhancers = window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?.({}) ?? compose;
const enhancer = composeEnhancers(applyMiddleware(thunk));

export default function configureStore() {
  let store;
  if (typeof window === 'undefined') { // server
    store = createStore(reducer, enhancer);
  } else { // client
    const initialState = window.__INITIAL_STATE__;
    console.log('initialState:', initialState)
    store = createStore(reducer, initialState, enhancer);
  }
  return store;
}

